import { Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class TitleService {
  private readonly titleChange = new Subject<void>();

  /** Emits when `setTitle` updates the document title (e.g. entity card after load). */
  public readonly titleChange$ = this.titleChange.asObservable();

  public constructor(private readonly title: Title) {}

  public setTitle(title: string): void {
    this.title.setTitle(title ? `${title} - ФРМ` : 'ФРМ');
    this.titleChange.next();
  }

  /** Page title without the ` - ФРМ` suffix (same format as `CustomTitleStrategy`). */
  public getPageTitle(): string {
    const docTitle = this.title.getTitle().trim();
    if (!docTitle || docTitle === 'ФРМ') {
      return '';
    }
    return docTitle.replace(/ - ФРМ$/, '').trim();
  }
}
